import { render, staticRenderFns } from "./baseSet.vue?vue&type=template&id=5d90b865&scoped=true&"
import script from "./baseSet.vue?vue&type=script&lang=js&"
export * from "./baseSet.vue?vue&type=script&lang=js&"
import style0 from "./baseSet.vue?vue&type=style&index=0&id=5d90b865&prod&lang=less&scoped=true&"
import style1 from "./baseSet.vue?vue&type=style&index=1&id=5d90b865&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d90b865",
  null
  
)

export default component.exports